import React, { useState, useEffect, useRef, forwardRef } from 'react';

import SurveyListHeader from '../../../component/layout/MainHeader';
import SurveyListSidebar from '../../../component/layout/MainSidebar';
import { Link } from 'react-router-dom';

import PuckEditor from './components/PuckEditor';
import Range from './components/Range';

export default function ROITemplates() {


    return (
        <>

            <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">

                        <div className="dashboard-page-outer flex-grow-1">
                            <div className="custom-breadcrumb">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/dashboard" className="home-item" title="Dashboard">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <strong>ROI Calculator</strong>
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <PuckEditor />



                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
